<template>
  <div class="news-root">
    <div
      class="d-flex align-center justify-space-between my-2 px-2"
      style="width: 100%;"
    >
      <div class="flex-grow-1">
        <v-btn
          @click="handleSelectTopic(topic)"
          outlined
          x-small
          v-for="(topic, idx) in topics"
          :key="idx"
          :color="selectedTopic === topic ? 'secondary' : '#727272'"
          class="rounded-lg mx-1 px-1 flex-1"
          :style="
            selectedTopic === topic ? 'background:#001e8e' : 'background: none'
          "
        >
          <span style="color: white !important; font-size:7px !important"
            >{{ topic === 'all' ? $t('newsChart.filters.all') : topic }}</span
          >
        </v-btn>
      </div>
      <v-select
        v-model="selectedTime"
        :items="newsDate"
        item-text="text"
        item-value="value"
        class="flex-shrink-0"
        :placeholder="$t('newsChart.filters.today')"
        dense
        style="max-width: 150px; max-height: 40px"
      />
    </div>

    <!--cols-->
    <div v-if="Object.keys(organizeDataFormat.groupedNews).length === 0">
      {{ $t('newsChart.noFiltersFound') }}
    </div>
    <div class="news-body">
      <the-news-col
        :latest="organizeDataFormat.latest"
        :col="organizeDataFormat.groupedNews"/>
    </div>

  </div>
</template>

<script>
import { useDisplayStore } from "@/store/index";
import TheNewsCol from "./TheNewsCol.vue";
import * as utils from "@/utils/utils.js";
import { mapStores } from "pinia";


export default {
  components: {
    TheNewsCol,
  },
  props: {
    slides: {
      required: true,
      type: Array,
    },
    fontSize: { type: Number, default: null },
  },
  data() {
    return {
      selectedTime: "",
      selectedTopic: "",
      currencies: [
        { code: "BRL", flag: "brazil_flag" },
        { code: "USD", flag: "usd_flag" },
        { code: "EUR", flag: "eu_flag" },
        { code: "JPY", flag: "japan_flag" },
      ],
    };
  },
  computed: {
    ...mapStores(useDisplayStore),
    newsDate() {
      return [
        { text: this.$t('newsChart.filters.today'), value: 'today' },
        { text: this.$t('newsChart.filters.yesterday'), value: 'yesterday' },
        { text: this.$t('newsChart.filters.all'), value: 'all' },
      ];
    },
    screenSizeFormat() {
      if (this.screenSize <= 1080) return "mobile";
      if (this.screenSize <= 1150) return "tablet";
      if (this.screenSize <= 1270) return "smallScreen";
      return "full";
    },
    newsData() {
      return this.slides.flatMap((slideGroup) =>
        Object.values(slideGroup.feed).filter((slide) => {
          const titleOrContent =
            slide.title.toLowerCase() + slide.summary.toLowerCase();
          return (
            !titleOrContent.includes("bitcoin") &&
            !titleOrContent.includes("crypto")
          );
        }),
      );
    },
    topics() {
      return [ 'all',
        ...new Set(
          this.newsData.flatMap((c) =>
          c.topics.filter(t=>t.relevance_score >= .7)
            .map((t) => {
              return utils.normalizeTopic(t.topic);
            }),
          ),
        ),
      ];
    },
    limitedSlides() {
      return this.slides.slice(0, 15);
    },
        organizeDataFormat() {
      if (!this.slides) {
        return;
      }
      let forexData = this.newsData.filter((slide, idx) => {
        //ticker_sentiment_score"
        if (!slide.ticker_sentiment) return false;
        const pos = slide.ticker_sentiment.filter(
          (s) => Number(s.ticker_sentiment_score) > 0,
        );
        return pos.length > 0;
      });
     
      forexData.sort((a, b) => {
        const dateA = new Date(
          `${a.time_published.slice(0, 4)}-${a.time_published.slice(
            4,
            6,
          )}-${a.time_published.slice(6, 8)}T${a.time_published.slice(
            9,
            11,
          )}:${a.time_published.slice(11, 13)}`,
        );
        const dateB = new Date(
          `${b.time_published.slice(0, 4)}-${b.time_published.slice(
            4,
            6,
          )}-${b.time_published.slice(6, 8)}T${b.time_published.slice(
            9,
            11,
          )}:${b.time_published.slice(11, 13)}`,
        );
        return dateB - dateA;
      });

      const filtered = this.filterDataByTopicAndTime(forexData);

      const mid = Math.ceil(filtered.length / 2);

      const latest = filtered[0]; // most current new

      const groupedNews = this.groupNews(filtered)

      return { groupedNews, latest };
    },
  },
  methods: {
    handleSelectTopic(topic) {
      this.selectedTopic = topic;
    },

    updateScreenSize() {
      this.screenSize = window.innerWidth;
    },
    groupNews(data){
      return data.reduce((acc, item)=>{
        const date = utils.formatFromCustomString(item.time_published, 'smallScreen')
        const author = item.authors?.[0] || this.$t('newsChart.unknownAuthor')

        if(!acc[date]) acc[date] = {}
        if(!acc[date][author]) acc[date][author] = []

        acc[date][author].push(item)

        return acc
      }, {})
    },
    filterDataByTopicAndTime(data) {
      return data.filter((c) => {
        const now = new Date();


          const startOfToday = new Date(now);
          startOfToday.setHours(0, 0, 0, 0);


          const startOfYesterday = new Date(startOfToday);
          startOfYesterday.setDate(startOfToday.getDate() - 1);

          const endOfYesterday = new Date(startOfToday);
          endOfYesterday.setMilliseconds(-1);


          const itemDate = utils.parseCustomDate(c.time_published)


          let timeMatch = true;

          if (this.selectedTime === "today") {
            timeMatch = itemDate >= startOfToday;
          }

          if (this.selectedTime === "yesterday") {
            timeMatch =
              itemDate >= startOfYesterday &&
              itemDate <= endOfYesterday;
          }

          // ---- TOPIC FILTER ----
          const topicMatch =
            this.selectedTopic === "all" ||
            !this.selectedTopic ||
            c.topics?.some((co) =>
              utils.normalizeTopic(co.topic).includes(this.selectedTopic) &&
              co.relevance_score >= .7
            );

          return topicMatch && timeMatch;
          });
    },
  },
  mounted() {
    window.addEventListener("resize", this.updateScreenSize);
  },
};
</script>

<style scoped>
.three-dot-icon {
  opacity: 0.5;
  position: absolute;
  left: 50%;
  bottom: -20px;
}
.news-root{
  height:100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.news-body{
  border-top: thin solid #3d3d3d; 
  border-bottom: thin solid #3d3d3d; 
  min-height:0;
  flex:1;
}
::v-deep .v-text-field__details {
  display: none;
}
::v-deep .v-text-field input {
  padding: 0;
}
</style>
